import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';
import each from 'lodash/each';
import map from 'lodash/map';

export default class FaqSection extends Component {
	constructor({ opened = false }) {
		super({
			element: '.faq',
			elements: {
				items: '.faq__element',
			},
		});

		this.isOpened = opened;
	}

	create() {
		super.createComponent();
		this.createTimeline();
		this.animateTimeline();

		each(this.elements.items, (el) => {
			if (el.dataset.revealed === 'true') {
				el.setAttribute('aria-expanded', 'true');
				GSAP.set(el.querySelector('.faq__element-body'), {
					maxHeight: '100vh',
				});
				GSAP.set(el.querySelector('.faq__element-svg'), {
					rotate: 360,
				});
			}
		});
		console.log('FAQ created');
		// this.addEventListeners();
	}

	createTimeline() {
		this.timelineInstant = GSAP.timeline({
			scrollTrigger: {
				trigger: this.element,
				start: 'top bottom',
				end: 'bottom top',
				toggleActions: 'restart none none reverse',
			},
		});
	}

	animateTimeline() {
		this.timelineInstant.fromTo(
			this.elements.items,
			{
				opacity: 0,
			},
			{
				opacity: 1,
				ease: 'out.expo',
				duration: 1.25,
				stagger: 0.2,
			}
		);
	}

	animateHeight() {}

	revealDescription(el) {
		let target;
		let targetSvg;
		const faqElement = el.closest('.faq__element');

		if (el.classList.contains('faq__element')) {
			target = el.querySelector('.faq__element-body');
			targetSvg = el.querySelector('.faq__element-svg');
		} else {
			const parent = el.closest('.faq__element');
			target = parent.querySelector('.faq__element-body');
			targetSvg = parent.querySelector('.faq__element-svg');
		}

		const currentStatus = faqElement.dataset.revealed;
		const newStatus = currentStatus === 'true' ? 'false' : 'true';
		faqElement.dataset.revealed = newStatus;
		faqElement.setAttribute('aria-expanded', newStatus);

		const vh = newStatus === 'true' ? '100vh' : '0vh';
		const rotate = newStatus === 'true' ? '360deg' : '180deg';

		GSAP.to(target, {
			maxHeight: vh,
			duration: 0.3,
			ease: 'power4.out',
		});

		GSAP.to(targetSvg, {
			rotate: rotate,
			duration: 0.7,
			ease: 'power4.out',
			onComplete: () => {
				if (target.dataset.revealed === 'true')
					GSAP.set(targetSvg, { rotate: 0 });
			},
		});
	}

	addEventListeners() {
		console.log('addEvents FAQ');
		each(this.elements.items, (el) => {
			el.addEventListener('click', (e) => {
				console.log('CLICk');
				this.revealDescription(e.target);
			});
		});
	}

	removeEventListeners() {
		each(this.elements.items, (el) => {
			el.removeEventListener('click', (e) => {
				this.revealDescription(e.target);
			});
		});
	}

	destroy() {
		this.removeEventListeners();
		super.destroy();

		if (this.timelineInstant) {
			this.timelineInstant.kill();
			this.timelineInstant = null;
		}
	}
}
